const CUSTOM_API_URL = `https://www.nant-power.com/admin/wp-json/custom/v1`;
const CONTENT_API_URL = `https://www.nant-power.com/admin/wp-json/wp/v2`;

export const CONTENT_ROUTES = {
  SERVICES: function (params) {
    return `${CONTENT_API_URL}/service/${params}`;
  },
  BANNERS: function (params) {
    return `${CONTENT_API_URL}/banner/${params}`;
  },
  PROJECTS: function (params) {
    return `${CONTENT_API_URL}/project/${params}`;
  },
  PROJECT: function (params) {
    return `${CONTENT_API_URL}/fund/${params}`;
  },
  MEDIA_BY_PAGE: function (id) {
    return `${CONTENT_API_URL}/media/?parent=${id}`;
  },
  MEDIA_BY_ID: function (id) {
    return `${CONTENT_API_URL}/media/${id}`;
  },
  POST_PAGE: function (type, slug) {
    return `${CONTENT_API_URL}${type}?slug=${slug}`;
  },
  POST_PAGE_BY_PARENT: function (type, parent_id) {
    return `${CONTENT_API_URL}${type}?parent=${parent_id}`;
  },
  SUBMIT_CONTACT_EMAIL: function () {
    return `${CUSTOM_API_URL}/contact-form-submission`;
  },
  SUBMIT_NEWSLETTER: function () {
    return `${CUSTOM_API_URL}/newsletter-form-submission`;
  },
  SUBMIT_JOB_APPLICATION: function () {
    return `${CUSTOM_API_URL}/career-application-submission`;
  },
  JOBS: function (params = "") {
    return `${CONTENT_API_URL}/job${params}`;
  },
  PAGES: function (params = "") {
    return `${CONTENT_API_URL}/pages${params}`;
  },
  POSTS: function (params = "") {
    return `${CONTENT_API_URL}/posts${params}`;
  },
  CATEGORIES: function (params = "") {
    return `${CONTENT_API_URL}/categories${params}`;
  },
  TAGS: function (params = "") {
    return `${CONTENT_API_URL}/tags${params}`;
  },
  SETTINGS: function () {
    return `${CONTENT_API_URL}/settings`;
  },
  GALLERIES: function (params = "") {
    return `${CONTENT_API_URL}/gallery${params}`;
  },
  LEADERSHIP_PAGE: function (slug) {
    return `${CONTENT_API_URL}/pages?slug=${slug}`;
  },
  LEADERSHIP: function (params = "") {
    return `${CONTENT_API_URL}/leadership${params}`;
  },
};
